import clsx from 'clsx'
import { useRef, useState } from 'react'

import play from 'assets/icons/play.svg'

interface MediaImageProps {
  media: {
    url?: string
    filename?: string
    type?: string
  }
  hidePlayIcon?: boolean
  onError?: () => void
  className?: string
  onPlayVideo?: () => void
  onPauseVideo?: () => void
}

export const MediaImage = ({ media, onError, className, onPlayVideo, onPauseVideo }: MediaImageProps) => {
  const [isPlaying, setIsPlaying] = useState(false)
  const videoRef = useRef<HTMLVideoElement>(null)
  if (media.type === 'image') {
    return <img src={media.url} alt="" className={clsx('h-full w-full object-cover', className)} onError={onError} />
  }
  if (media.type === 'video') {
    return (
      <div className={clsx('h-full w-full object-cover relative', className)}>
        {!isPlaying && (
          <img
            src={play}
            alt="Play Video"
            className="cursor-pointer absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-10"
            onClick={() => videoRef.current?.play()}
          />
        )}
        <video
          className="w-full h-full object-cover"
          ref={videoRef}
          src={media.url}
          controls={isPlaying}
          // controls={true}
          onPlay={() => {
            setIsPlaying(true)
            onPlayVideo?.()
          }}
          onSeeking={() => {
            setIsPlaying(true)
            onPlayVideo?.()
          }}
          onPause={() => {
            setIsPlaying(false)
            onPauseVideo?.()
          }}
          onEnded={() => setIsPlaying(false)}
        />
      </div>
    )
  }
  onError?.()
}
